import React, {Component} from 'react';
import {orgId, defaultErrorHandler} from '../../../context/context';
import customFormsV2Client from '../../../infrastructure/acerill/custom-forms-v2-client';
import CenteredSpinner from '../../../libs/react-components-admin/spinners/centered-spinner';

const ViewState = Object.freeze({
  DISPLAYED: Symbol('DISPLAYED'),
  HIDDEN: Symbol('HIDDEN')
});

export default class ZapierKey extends Component {

  constructor(props) {
    super(props);
    this.state = {
      viewState: ViewState.HIDDEN,
      apiKey: null,
    };
  }

  componentDidMount() {
    customFormsV2Client
      .findZapierApiKey()
      .then(data => this.setState({apiKey: data.apiKey}))
      .catch(defaultErrorHandler);
  }

  render() {
    if (!this.state.apiKey) {
      return <CenteredSpinner/>;
    }
    return <div className="row">
      <div className="col-auto">Client ID</div>
      <div className="col"><tt>{orgId}</tt></div>

      <div className="w-100"/>

      <div className="col-auto">API Key</div>
      <div className="col">
        <tt className={this.state.viewState === ViewState.DISPLAYED ? 'visible' : 'invisible'}>{this.state.apiKey}</tt>
        <span className="ms-3">
          <button className="btn btn-sm btn-secondary px-3"
                  onClick={() => this.setState({viewState: this.state.viewState === ViewState.HIDDEN ? ViewState.DISPLAYED : ViewState.HIDDEN})}>
            {this.state.viewState === ViewState.HIDDEN ? 'Show' : 'Hide'} API key
          </button>
        </span>
      </div>
    </div>
  }

}
